import React from 'react'
import { DepositAccount } from '@ally/data-types-accounts'
import { maskAccountNumber } from '@ally/aos-utils'
import { Box } from '@ally/metronome-ui'
import { useAccountTypes } from '../../../AccountTypeContext'
import { StyledSelect } from './StyledComponents'
import { useWidget } from './WidgetContext'

function formattedAccountLabel(account: DepositAccount): string {
  const maxAcctNameLength = 7

  return `${account.accountNickname.substr(0, maxAcctNameLength - 1)}${
    account.accountNickname.length > maxAcctNameLength ? '...' : ''
  } ${maskAccountNumber(account.accountNumberPvtEncrypt)}`
}

const AccountSelect: React.FC = () => {
  const { stkAccounts } = useAccountTypes()
  const { setActiveAccountId } = useWidget()

  const options = stkAccounts.map(account => {
    return {
      value: account.accountId,
      label: formattedAccountLabel(account),
    }
  })

  return stkAccounts.length > 1 ? (
    <>
      <StyledSelect
        id="account"
        data-testid="stk-widget-account-select"
        ariaLabel="Select to view savings accounts"
        options={options}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>): void => {
          setActiveAccountId(e.currentTarget.value)
        }}
      />
    </>
  ) : (
    <Box size="sm">{formattedAccountLabel(stkAccounts[0])}</Box>
  )
}

export default AccountSelect
